module.exports = __webpack_public_path__ + "assets/img/box-3.544bb12f.png";